import gsap from 'gsap';

import { isPortrait, isSmartphone } from '../_app/cuchillo/core/Basics';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { SliderScroll } from '../_app/cuchillo/components/SliderScroll';
import { ScrollItem__Default } from './ScrollItem__Default';

class ScrollItem__Teams extends ScrollItem__Default {
    factor;
    _call;
    _teams;
    _slider;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.factor = isPortrait ? 0.8 : 0.25;

        this._teams = __link.classList.contains('team-slider')
            ? __link
            : __link.querySelector('.team-slider');

        if (this._teams) {
            this._slider = new SliderScroll(this._teams, {
                interaction: true,
                hasScrollbar: false,
                itemClass: ScrollItem__SliderImages__Item
            });
        }

        this._call = () => this.loop();

        this.onShow = () => {
            this.showEffect();
            gsap.ticker.add(this._call);
        };

        this.onHide = () => {
            gsap.ticker.remove(this._call);
        };
    }

    //==================================================================================================================
    //          PUBLIC
    //==================================================================================================================
    loop() {
        if (this._slider) this._slider.loop();

        const p = Maths.precission(this.progressInside, 2) * this.factor;
        const trans = -100 * p;
        this._item.style.setProperty('--translation', `${trans}%`);

        if (isSmartphone) return;

        const scale = Maths.clamp(
            Maths.map(1 - this.progressInside, 0.4, 0.85, 1, 0.95),
            0.95,
            1
        );

        // gsap.set(this._teams, {
        //     scaleX: scale,
        //     scaleY: scale
        // });
    }

    dispose() {
        if (this._slider) this._slider.dispose();
        super.dispose();
    }

    resize(__w, __h) {
        super.resize(__w, __h);
        this.factor = isPortrait ? 0.8 : 0.25;
        if (this._slider) this._slider.resize();
    }
}

Scroll._registerClass('team', ScrollItem__Teams);

class ScrollItem__SliderImages__Item extends VScroll_Item {
    hasHiddenEnabled = false;
    info;

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }
}
